import Vue from 'vue'
import http from '@/services/http.service'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.itemCategories) this.$itemCategories = options.itemCategories
    else if (options.parent && options.parent.$itemCategories)
      this.$itemCategories = options.parent.$itemCategories
  },
})

export default {
  async get(company) {
    const response = await http.get(`/item_categories/${company}`)
    return response.data
  },
}
